import React, { useContext, useState, useEffect } from "react";
import theme from "../../themes/theme";
import "./Navbar.css";
import { ThemeProvider } from "@emotion/react";
import { Avatar, Button } from "@mui/material";
import { useNavigate } from "react-router";
import { AppContext } from "../../context/AppContext";
import axios from "axios";
import BASE_URL from "../../config/api";
import ProfileDetailsModal from "../Modals/ProfileDetailsModal";
import { ToastContainer, toast } from "react-toastify";

export default function Navbar() {
  const { token, setToken } = useContext(AppContext);
  const { userId, setUserId } = useContext(AppContext);
  const [userDetails, setUserDetails] = useState(null);
  const [detailsOpen, setDetailsOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem("token");
    setUserId(null);
    localStorage.removeItem("id");
    navigate("/");
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        if (userId) {
          const userDetailsResponse = await axios.get(
            `${BASE_URL}/users/${userId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setUserDetails(userDetailsResponse.data);
        }
      } catch (error) {
        console.error("Error fetching user details:", error.message);
      }
    };

    if (userId) {
      fetchUserDetails();
    }
  }, [userId, token]);

  const handleProfileClick = () => {
    setDetailsOpen(true);
  };

  const handleDetailsUpdate = async (updatedDetails) => {
    try {
      if (userId) {
        const response = await axios.put(
          `${BASE_URL}/users/${userId}`,
          {
            walletAddress: updatedDetails.walletAddress,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Profile details successfully updated!");
        setUserDetails(response.data);
        setDetailsOpen(false);
      }
    } catch (error) {
      console.error("Error updating user details:", error.message);
    }
  };

  const handleCloseDetails = () => {
    setDetailsOpen(false);
  };

  return (
    <div className="nav-container">
      <ThemeProvider theme={theme}>
        {detailsOpen && (
          <ProfileDetailsModal
            isOpen={detailsOpen}
            userDetails={userDetails}
            onSubmitHandler={handleDetailsUpdate}
            onCloseHandler={handleCloseDetails}
          />
        )}
        {userDetails && (
          <Avatar
            alt={userDetails.name}
            src={`${BASE_URL}${userDetails.imagePath}`}
            onClick={handleProfileClick}
          />
        )}
        <Button variant="contained" onClick={handleLogout}>
          Logout
        </Button>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
        />
      </ThemeProvider>
    </div>
  );
}
